import { http } from '@/http/axios.js';
import {hideScreenLoading, showScreenLoading} from "@/http/loading";
import axios from 'axios'
import {getToken} from "@/utils/auth";
import {dateFormat} from "@/utils";

// list
export function getListAPI(params) {
  return http({
    url: '/admin/store/goods/page',
    method: 'get',
    params
  })
}
// 根据ID列表查询商品
export function getListByIdsAPI(params) {
  return http({
    url: "/admin/store/goods/list",
    method: "get",
    params,
  });
}
// 查询品牌列表
export function getBrandListAPI(params) {
  return http({
    url: "/admin/oprt/goodsBrand/enumList",
    method: "get",
    params,
  });
}
export function getAttrListAPI(params) {
  return http({
    url: '/admin/store/goods/attr/list',
    method: 'get',
    params
  })
}
// delete
export function deleteAPI(id) {
  return http({
    url: '/admin/store/goods/delete',
    method: 'post',
    data: { id }
  })
}
// add
export function addAPI(data) {
  return http({
    url: '/admin/store/goods/add',
    method: 'post',
    data
  })
}
// edit
export function editAPI(data) {
  return http({
    url: '/admin/store/goods/edit',
    method: 'post',
    data
  })
}
// detail
export function getDetailAPI(id) {
  return http({
    url: '/admin/store/goods/detail',
    method: 'get',
    params: { id }
  })
}
// 修改回收价
export function editRecyclePriceAPI(data) {
  return http({
    url: "/admin/store/goods/recyclePrice/edit",
    method: "post",
    data,
  });
}
// 修改状态
export function changeStatusAPI(data) {
  return http({
    url: "/admin/store/goods/status/edit",
    method: "post",
    data,
  });
}
// 导出
export function exportAPI(data) {
  showScreenLoading();
  axios({
    method: "post",
    url: "/api/admin/store/goods/export",
    responseType: "blob",
    data,
    headers: {
      Authorization: getToken() || "",
    },
  })
      .then(async (res) => {
        hideScreenLoading();
        let data = res.data;
        let url = window.URL.createObjectURL(new Blob([data]));
        let a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        let filename = `果冻租门店商品列表${dateFormat()}.xlsx`;
        a.setAttribute("download", decodeURIComponent(filename));
        document.body.appendChild(a);
        a.click(); //执行下载
        window.URL.revokeObjectURL(a.href); //释放url
        document.body.removeChild(a); //释放标签
      })
      .catch((error) => {
        hideScreenLoading();
        console.log(error);
      });
}

export function importStoreGoodsAPI(data) {
  return http({
    url: "/admin/store/goods/import",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
